import React, { useEffect, useState } from "react";
import {
  roundOffCost,
  roundOffCostWithNoFraction,
} from "../../../Components/Functions/amt.fun";
import QuotationAmount from "./quotation_amount";
function roundUp(cost) {
  cost = Math.ceil(cost);
  return cost;
}
const getRevenue = (price, plant, allQData) => {
  let harvest = 0;

  switch (plant?.grow_system) {
    case "nftA":
      harvest =
        plant.productionPerPlantMonth *
        allQData?.number_of_plants?.numberOfPlantsInA_Frame;
      break;

    case "fb":
      harvest =
        plant.productionPerPlantMonth *
        allQData?.number_of_plants?.numberOfPlantsInFlatBed;
      break;

    case "gb":
      harvest =
        plant.productionPerPlantMonth *
        allQData?.number_of_plants?.numberOfPlantsInGrowBag;
      break;

    case "db":
      harvest =
        plant.productionPerPlantMonth *
        allQData?.number_of_plants?.numberOfPlantsInDutchBucket;
      break;

    default:
      harvest = 0;
  }

  // Round once and use everywhere
  harvest = roundUp(harvest);

  return price * harvest;
};

const getHeading = (italianBasilArray, bellPaperArray) => {
  if (
    italianBasilArray &&
    bellPaperArray &&
    italianBasilArray.length > 0 &&
    bellPaperArray.length > 0
  ) {
    return `Case study: ${italianBasilArray?.[0]?.plantName} + ${bellPaperArray?.[0]?.plantName}`;
  } else if (italianBasilArray && italianBasilArray.length > 0) {
    return `Case study: ${italianBasilArray?.[0]?.plantName}`;
  } else if (bellPaperArray && bellPaperArray.length > 0) {
    return `Case study: ${bellPaperArray?.[0]?.plantName}`;
  } else {
    return "Case study: N/A";
  }
};

const getGrowSystem = (grow_system) => {
  if (grow_system === "nftA") {
    return `NFT (A-Frame)`;
  }
  if (grow_system === "gb") {
    return `Grow Bag`;
  }
  if (grow_system === "db") {
    return `Dutch Bucket`;
  }

  if (grow_system === "fb") {
    return `Flat-NFT`;
  }
};

const getTotalCost = (italianBasilArray, bellPaperArray, allQData) => {
  let tCost = 0;
  if (italianBasilArray?.length > 0) {
    italianBasilArray.map((plant) => {
      tCost += getRevenue(
        (plant?.min_price + plant?.max_price) / 2,
        plant,
        allQData
      );
    });
  }
  if (bellPaperArray?.length > 0) {
    bellPaperArray.map((plant) => {
      tCost += getRevenue(
        (plant?.min_price + plant?.max_price) / 2,
        plant,
        allQData
      );
    });
  }
  return tCost;
};

const getProductionCost = (allQData, totalCost, totalPer, qCost) => {
  let pc1 =
    (allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
    allQData?.opex_cost?.opex_labour_cost * 12 +
    totalCost * 0.9 * 0.12 +
    allQData?.opex_cost?.opex_electricity_cost * 12 +
    totalCost * 0.9 * 12 * 0.0025;
  let pc2 =
    (allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
    allQData?.opex_cost?.opex_labour_cost * 12 +
    totalCost * 0.9 * 0.12 +
    allQData?.opex_cost?.opex_electricity_cost * 12 +
    totalCost * 0.9 * 12 * 0.0025 +
    qCost * 0.005;

  let pc3 =
    (allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
    allQData?.opex_cost?.opex_labour_cost * 12 +
    totalCost * 0.9 * 0.12 +
    allQData?.opex_cost?.opex_electricity_cost * 12 +
    totalCost * 0.9 * 12 * 0.0025 +
    qCost * 0.01;
  let pc4 =
    (allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
    allQData?.opex_cost?.opex_labour_cost * 12 +
    totalCost * 0.9 * 0.12 +
    allQData?.opex_cost?.opex_electricity_cost * 12 +
    totalCost * 0.9 * 12 * 0.0025 +
    qCost * 0.015;
  let pc5 =
    (allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
    allQData?.opex_cost?.opex_labour_cost * 12 +
    totalCost * 0.9 * 0.12 +
    allQData?.opex_cost?.opex_electricity_cost * 12 +
    totalCost * 0.9 * 12 * 0.0025 +
    qCost * 0.02;
  let pc6 =
    (allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
    allQData?.opex_cost?.opex_labour_cost * 12 +
    totalCost * 0.9 * 0.12 +
    allQData?.opex_cost?.opex_electricity_cost * 12 +
    totalCost * 0.9 * 12 * 0.0025 +
    qCost * 0.025;
  let pc7 =
    (allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
    allQData?.opex_cost?.opex_labour_cost * 12 +
    totalCost * 0.9 * 0.12 +
    allQData?.opex_cost?.opex_electricity_cost * 12 +
    totalCost * 0.9 * 12 * 0.0025 +
    qCost * 0.03;

  return { pc1, pc2, pc3, pc4, pc5, pc6, pc7 };
};
const getTotalNetProfit = (allQData, totalCost, totalPer, qCost) => {
  let np1 =
    totalCost * totalPer * 12 -
    ((allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
      allQData?.opex_cost?.opex_labour_cost * 12 +
      totalCost * 0.9 * 0.12 +
      allQData?.opex_cost?.opex_electricity_cost * 12 +
      totalCost * 0.9 * 12 * 0.0025);
  let np2 =
    totalCost * totalPer * 12 -
    ((allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
      allQData?.opex_cost?.opex_labour_cost * 12 +
      totalCost * 0.9 * 0.12 +
      allQData?.opex_cost?.opex_electricity_cost * 12 +
      totalCost * 0.9 * 12 * 0.0025 +
      qCost * 0.005);
  let np3 =
    totalCost * totalPer * 12 -
    ((allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
      allQData?.opex_cost?.opex_labour_cost * 12 +
      totalCost * 0.9 * 0.12 +
      allQData?.opex_cost?.opex_electricity_cost * 12 +
      totalCost * 0.9 * 12 * 0.0025 +
      qCost * 0.01);

  let np4 =
    totalCost * totalPer * 12 -
    ((allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
      allQData?.opex_cost?.opex_labour_cost * 12 +
      totalCost * 0.9 * 0.12 +
      allQData?.opex_cost?.opex_electricity_cost * 12 +
      totalCost * 0.9 * 12 * 0.0025 +
      qCost * 0.015);
  let np5 =
    totalCost * totalPer * 12 -
    ((allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
      allQData?.opex_cost?.opex_labour_cost * 12 +
      totalCost * 0.9 * 0.12 +
      allQData?.opex_cost?.opex_electricity_cost * 12 +
      totalCost * 0.9 * 12 * 0.0025 +
      qCost * 0.02);
  let np6 =
    totalCost * totalPer * 12 -
    ((allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
      allQData?.opex_cost?.opex_labour_cost * 12 +
      totalCost * 0.9 * 0.12 +
      allQData?.opex_cost?.opex_electricity_cost * 12 +
      totalCost * 0.9 * 12 * 0.0025 +
      qCost * 0.025);
  let np7 =
    totalCost * totalPer * 12 -
    ((allQData?.opex_cost?.opex_growmedia_cost +
      allQData?.opex_cost?.opex_seeds_cost +
      allQData?.opex_cost?.opex_packaging_cost +
      allQData?.opex_cost?.opex_solutionA_cost +
      allQData?.opex_cost?.opex_solutionB_cost) *
      12 +
      allQData?.opex_cost?.opex_labour_cost * 12 +
      totalCost * 0.9 * 0.12 +
      allQData?.opex_cost?.opex_electricity_cost * 12 +
      totalCost * 0.9 * 12 * 0.0025 +
      qCost * 0.03);
  return { np1, np2, np3, np4, np5, np6, np7 };
};

let BreakEvenStatus = (amt) => {
  return (
    <td
      const
      style={{
        border: "1px solid #181818",
        textAlign: "left",
        margin: "0px",
        padding: "0px",
        paddingLeft: "3px",
        fontSize: "17px",
        borderCollapse: "collapse",
      }}
      className={amt > 0 ? "text-white bg-success" : "text-white bg-danger"}
    >
      {amt > 0 ? "+ VE" : "- VE"}
    </td>
  );
};

const FinancialAnalysis = ({ data, allQData }) => {
  const [italianBasilArray, setItalianBasilArray] = useState([]);
  const [bellPaperArray, setBellPaperArray] = useState([]);
  const [totalCost, setTotalCost] = useState(0);
  const [qCost, setQuotationCost] = useState(0);
  const [totalPer, setTotalPerctage] = useState(0);
  const [pc1, setPc1] = useState(0);
  const [pc2, setPc2] = useState(0);
  const [pc3, setPc3] = useState(0);
  const [pc4, setPc4] = useState(0);
  const [pc5, setPc5] = useState(0);
  const [pc6, setPc6] = useState(0);
  const [pc7, setPc7] = useState(0);
  const [np1, setNp1] = useState(0);
  const [np2, setNp2] = useState(0);
  const [np3, setNp3] = useState(0);
  const [np4, setNp4] = useState(0);
  const [np5, setNp5] = useState(0);
  const [np6, setNp6] = useState(0);
  const [np7, setNp7] = useState(0);
  // allQData = {
  //   ...allQData,
  //   opex_cost: { ...allQData?.opex_cost, opex_labour_cost: 0 },
  // };
  useEffect(() => {
    let totalPerctage = 0.9;
    if (allQData?.area_in?.area_in_sqmeter) {
      let area = allQData?.area_in?.area_in_sqmeter;
      if (area > 2000 && area <= 4000) {
        totalPerctage = 0.85;
      } else if (area > 4000 && area <= 6000) {
        totalPerctage = 0.8;
      } else if (area > 6000) {
        totalPerctage = 0.75;
      }
    }
    let total = 0;
    if (allQData?.quotationNumber?.includes("A/V2")) {
      total = +allQData?.quotationMatrixCost?.asPerIndustryCost;
    } else {
      total =
        +allQData?.input_info?.overrideUnitCost ||
        +allQData?.quotationMatrixCost?.total_cost;
    }

    if (
      allQData?.input_info?.addOnParticulars &&
      allQData?.input_info?.addOnParticularsPrice
    ) {
      total += +allQData?.input_info?.addOnParticularsPrice;
    }

    setTotalPerctage(totalPerctage);
    setQuotationCost(total);
  }, [allQData]);
  useEffect(() => {
    let area = allQData?.area_in?.area_in_sqmeter;
    let ftDataItalianBasil = allQData?.plant_grow?.updatedPlantsList?.filter(
      (item) => {
        return area < 2000
          ? item?.plantName === "Italian Basil"
          : item?.plantName === "Super Spinach";
      }
    );
    let ftDataBellPapper = allQData?.plant_grow?.updatedPlantsList?.filter(
      (item) => {
        return area < 2000
          ? item?.plantName === "Bell Papper"
          : item?.plantName === "Cucumber English";
      }
    );
    setBellPaperArray(ftDataBellPapper);
    setItalianBasilArray(ftDataItalianBasil);
  }, [allQData]);
  let serial = 1;
  let breakEvenCost = 0;
  let breakEvenCostStatus = 0;
  useEffect(() => {
    if (allQData && italianBasilArray && bellPaperArray) {
      setTotalCost(getTotalCost(italianBasilArray, bellPaperArray, allQData));
    }
  }, [allQData, italianBasilArray, bellPaperArray]);

  useEffect(() => {
    if (allQData && totalCost && totalPer && qCost) {
      let value = getProductionCost(allQData, totalCost, totalPer, qCost);
      setPc1(value.pc1);
      setPc2(value.pc2);
      setPc3(value.pc3);
      setPc4(value.pc4);
      setPc5(value.pc5);
      setPc6(value.pc6);
      setPc7(value.pc7);
    }
  }, [allQData, totalCost, totalPer, qCost]);
  useEffect(() => {
    if (allQData && totalCost && totalPer && qCost) {
      let value = getTotalNetProfit(allQData, totalCost, totalPer, qCost);
      setNp1(value.np1);
      setNp2(value.np2);
      setNp3(value.np3);
      setNp4(value.np4);
      setNp5(value.np5);
      setNp6(value.np6);
      setNp7(value.np7);
    }
  }, [allQData, totalCost, totalPer, qCost]);
  useEffect(() => {
    if (allQData?.input_info?.isGrowSlab)
      setTimeout(() => {
        const element = document.getElementById("gb-gs");
        element.innerHTML = element.innerHTML.replace("GROW-BAG", "GROW-SLAB");
        element.innerHTML = element.innerHTML.replace("Grow bag", "Grow slab");
        element.innerHTML = element.innerHTML.replace(
          "grow bags",
          "grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow bags",
          "Grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow Bags",
          "Grow Slabs"
        );
        element.innerHTML = element.innerHTML.replace("Grow Bag", "Grow Slab");
        element.innerHTML = element.innerHTML.replace("Growbag", "Growslab");
        element.innerHTML = element.innerHTML.replace("Growbags", "Growslabs");
        element.innerHTML = element.innerHTML.replace("growbags", "growslabs");
      }, 1000);
  }, [allQData]);
  return (
    <div id="gb-gs">
      <h3 style={{ textAlign: "center", fontSize: "25px" }}>
        {getHeading(italianBasilArray, bellPaperArray)}
      </h3>
      <p
        className="fw-bold mt-1 mb-0 text-uppercase  text-center"
        style={{
          fontSize: "1rem",
        }}
      >
        {italianBasilArray &&
          italianBasilArray.length > 0 &&
          italianBasilArray.map((plant, index) => {
            return (
              <span key={index}>
                {`${plant.plantName} (${getGrowSystem(
                  plant.grow_system
                )}) Gross Profit: ${roundOffCost(
                  getRevenue(
                    (plant?.min_price + plant?.max_price) / 2,
                    plant,
                    allQData
                  )
                )}`}
                <br />
              </span>
            );
          })}
        {bellPaperArray &&
          bellPaperArray.length > 0 &&
          bellPaperArray.map((plant, index) => {
            return (
              <span key={index}>
                {`${plant.plantName} (${getGrowSystem(
                  plant.grow_system
                )}) Gross Profit: ${roundOffCost(
                  getRevenue(
                    (plant?.min_price + plant?.max_price) / 2,
                    plant,
                    allQData
                  )
                )}`}
                <br />
              </span>
            );
          })}
        {italianBasilArray &&
          bellPaperArray &&
          allQData &&
          `Total Gross Profit: ${roundOffCost(
            getTotalCost(italianBasilArray, bellPaperArray, allQData)
          )}`}
      </p>
      <h3></h3>
      {/* {allQData && <QuotationAmount allQData={allQData} />} */}
      <p
        className="fw-bold mt-4 mb-0 text-uppercase"
        style={{
          fontSize: "1rem",
        }}
      >
        Capacity Utilization of Sales
      </p>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "2%" }}>Sr.</th>
            <th style={{ width: "14%" }}>Particulars</th>
            <th style={{ width: "14%" }}>1st Year</th>
            <th style={{ width: "14%" }}>2nd Year</th>
            <th style={{ width: "14%" }}>3rd Year</th>
            <th style={{ width: "14%" }}>4th Year</th>
            <th style={{ width: "14%" }}>5th Year</th>
            <th style={{ width: "14%" }}>6th Year</th>
            <th style={{ width: "14%" }}>7th Year</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td>Capacity Utilization</td>
            <td>{totalPer && totalPer * 100}%</td>
            <td>{totalPer && totalPer * 100}%</td>
            <td>{totalPer && totalPer * 100}%</td>
            <td>{totalPer && totalPer * 100}%</td>
            <td>{totalPer && totalPer * 100}%</td>
            <td>{totalPer && totalPer * 100}%</td>
            <td>{totalPer && totalPer * 100}%</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Sales / Receipts </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
          </tr>
        </tbody>
      </table>
      <p
        className="fw-bold mt-4 mb-0 text-uppercase"
        style={{
          fontSize: "1rem",
        }}
      >
        Projected Profit & Loss Account:
      </p>
      <table style={{ width: "100%", fontSize: "14px" }}>
        <thead>
          <tr style={{ fontSize: "14px" }}>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "15%" }}>Particulars</th>
            <th>1st Year</th>
            <th>2nd Year</th>
            <th>3rd Year</th>
            <th>4th Year</th>
            <th>5th Year</th>
            <th>6th Year</th>
            <th>7th Year</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td>Sales / Receipts</td>

            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * totalPer * 12)}
            </td>
          </tr>

          <tr>
            <td></td>
            <td>
              <b>Manufacturing Expenses</b>
            </td>
            <td></td> <td></td>
            <td></td> <td></td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Raw Materials</td>

            <td>
              {roundOffCostWithNoFraction(
                (allQData?.opex_cost?.opex_growmedia_cost +
                  allQData?.opex_cost?.opex_seeds_cost +
                  allQData?.opex_cost?.opex_packaging_cost +
                  allQData?.opex_cost?.opex_solutionA_cost +
                  allQData?.opex_cost?.opex_solutionB_cost) *
                  12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                (allQData?.opex_cost?.opex_growmedia_cost +
                  allQData?.opex_cost?.opex_seeds_cost +
                  allQData?.opex_cost?.opex_packaging_cost +
                  allQData?.opex_cost?.opex_solutionA_cost +
                  allQData?.opex_cost?.opex_solutionB_cost) *
                  12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                (allQData?.opex_cost?.opex_growmedia_cost +
                  allQData?.opex_cost?.opex_seeds_cost +
                  allQData?.opex_cost?.opex_packaging_cost +
                  allQData?.opex_cost?.opex_solutionA_cost +
                  allQData?.opex_cost?.opex_solutionB_cost) *
                  12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                (allQData?.opex_cost?.opex_growmedia_cost +
                  allQData?.opex_cost?.opex_seeds_cost +
                  allQData?.opex_cost?.opex_packaging_cost +
                  allQData?.opex_cost?.opex_solutionA_cost +
                  allQData?.opex_cost?.opex_solutionB_cost) *
                  12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                (allQData?.opex_cost?.opex_growmedia_cost +
                  allQData?.opex_cost?.opex_seeds_cost +
                  allQData?.opex_cost?.opex_packaging_cost +
                  allQData?.opex_cost?.opex_solutionA_cost +
                  allQData?.opex_cost?.opex_solutionB_cost) *
                  12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                (allQData?.opex_cost?.opex_growmedia_cost +
                  allQData?.opex_cost?.opex_seeds_cost +
                  allQData?.opex_cost?.opex_packaging_cost +
                  allQData?.opex_cost?.opex_solutionA_cost +
                  allQData?.opex_cost?.opex_solutionB_cost) *
                  12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                (allQData?.opex_cost?.opex_growmedia_cost +
                  allQData?.opex_cost?.opex_seeds_cost +
                  allQData?.opex_cost?.opex_packaging_cost +
                  allQData?.opex_cost?.opex_solutionA_cost +
                  allQData?.opex_cost?.opex_solutionB_cost) *
                  12
              )}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Wages</td>

            <td>
              {" "}
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_labour_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_labour_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_labour_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_labour_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_labour_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_labour_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_labour_cost * 12
              )}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Repairs & Maintenance</td>

            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 0.12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 0.12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 0.12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 0.12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 0.12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 0.12)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 0.12)}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Power & Fuel</td>

            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_electricity_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_electricity_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_electricity_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_electricity_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_electricity_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_electricity_cost * 12
              )}
            </td>
            <td>
              {roundOffCostWithNoFraction(
                allQData?.opex_cost?.opex_electricity_cost * 12
              )}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Other Expenses</td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.0025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.0025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.0025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.0025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.0025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.0025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.0025)}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Crop Wastage</td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Transport Wastage</td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                qCost &&
                roundOffCostWithNoFraction(totalCost * 0.9 * 12 * 0.025)}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Depreciation</td>
            <td>0</td>
            <td> {qCost && roundOffCostWithNoFraction(qCost * 0.005)}</td>
            <td> {qCost && roundOffCostWithNoFraction(qCost * 0.01)}</td>
            <td> {qCost && roundOffCostWithNoFraction(qCost * 0.015)}</td>
            <td> {qCost && roundOffCostWithNoFraction(qCost * 0.02)}</td>
            <td> {qCost && roundOffCostWithNoFraction(qCost * 0.025)}</td>
            <td> {qCost && roundOffCostWithNoFraction(qCost * 0.03)}</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>
              <b>Production Cost</b>
            </td>

            <td> {pc1 && roundOffCostWithNoFraction(pc1)}</td>
            <td>{pc2 && roundOffCostWithNoFraction(pc2)}</td>
            <td> {pc3 && roundOffCostWithNoFraction(pc3)}</td>
            <td>{pc4 && roundOffCostWithNoFraction(pc4)}</td>
            <td>{pc5 && roundOffCostWithNoFraction(pc5)}</td>
            <td>{pc6 && roundOffCostWithNoFraction(pc6)}</td>
            <td>{pc7 && roundOffCostWithNoFraction(pc7)}</td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>
              <b>Cost Per Plant</b>
            </td>

            <td>
              {pc1 &&
                roundOffCostWithNoFraction(
                  pc1 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {pc2 &&
                roundOffCostWithNoFraction(
                  pc2 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {pc3 &&
                roundOffCostWithNoFraction(
                  pc3 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {pc4 &&
                roundOffCostWithNoFraction(
                  pc4 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {pc5 &&
                roundOffCostWithNoFraction(
                  pc5 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {pc6 &&
                roundOffCostWithNoFraction(
                  pc6 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {pc7 &&
                roundOffCostWithNoFraction(
                  pc7 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Sales Per Plant</td>

            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>
              <b>Net Profit Per Plant</b>
            </td>

            <td>
              {totalCost &&
                totalPer &&
                pc1 &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants -
                    pc1 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                pc2 &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants -
                    pc2 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>

            <td>
              {totalCost &&
                totalPer &&
                pc3 &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants -
                    pc3 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                pc4 &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants -
                    pc4 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                pc5 &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants -
                    pc5 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                pc6 &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants -
                    pc6 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
            <td>
              {totalCost &&
                totalPer &&
                pc7 &&
                roundOffCostWithNoFraction(
                  (totalCost * totalPer * 12) /
                    allQData?.number_of_plants.maximumNumberOfPlants -
                    pc7 / allQData?.number_of_plants.maximumNumberOfPlants
                )}
            </td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>
              <b>Total Net Profit</b>
            </td>

            <td>{np1 && roundOffCostWithNoFraction(np1)}</td>
            <td>{np2 && roundOffCostWithNoFraction(np2)}</td>
            <td>{np3 && roundOffCostWithNoFraction(np3)}</td>
            <td>{np4 && roundOffCostWithNoFraction(np4)}</td>
            <td>{np5 && roundOffCostWithNoFraction(np5)}</td>
            <td>{np6 && roundOffCostWithNoFraction(np6)}</td>
            <td>{np7 && roundOffCostWithNoFraction(np7)}</td>
          </tr>
        </tbody>
      </table>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      {/* have to work after coustomar discussion */}
      {/* 
      <h3>PROJECTED BALANCE SHEET:</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "15%" }}>Particulars</th>
            <th>0 Year</th>
            <th>1st Year</th>
            <th>2nd Year</th>
            <th>3rd Year</th>
            <th>4th Year</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td>
              <b>LIABILITIES :</b>
            </td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Promoters Capital</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Profit</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Term Loan</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Working Capital Loan</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Current Liabilities</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Sundry Creditors</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td></td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>
              <b>ASSETS :</b>
            </td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Gross Fixed Assets : </td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Less : Depreciation</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Net Fixed Assets</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Preliminary & Pre-Op. Expenses</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Current Assets</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Cash in Bank/Hand</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
          <tr>
            <td>{++serial}</td>
            <td>Total</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>
        </tbody>
      </table> */}
      {/* <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div> */}
      <p
        className="fw-bold mt-4 mb-0 text-uppercase"
        style={{
          fontSize: "1rem",
        }}
      >
        CASH FLOW STATEMENT (1st-4th years):
      </p>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "15%" }}>Particulars</th>
            <th>1st Year</th>
            <th>2nd Year</th>
            <th>3rd Year</th>
            <th>4th Year</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td>Net Profit</td>
            <td>0</td>
            <td>{roundOffCost(np1)}</td>
            <td>{roundOffCost(np2)}</td>
            <td>{roundOffCost(np3)}</td>
          </tr>

          <tr>
            <td></td>
            <td>
              <b>Total</b>
            </td>
            <td>0</td>
            <td>{roundOffCost(np1)}</td>
            <td>{roundOffCost(np1 + np2)}</td>
            <td>{roundOffCost(np1 + np2 + np3)}</td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>Investement</td>
            <td>{roundOffCost(qCost)}</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>Total Assets</td>

            <td>{qCost && roundOffCost(qCost)}</td>
            <td>{qCost && roundOffCost(qCost)}</td>
            <td>{qCost && roundOffCost(qCost - qCost * 0.005)}</td>
            <td>
              {qCost && roundOffCost(qCost - qCost * 0.005 - qCost * 0.01)}
            </td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>Total Valuation</td>

            <td>{qCost && roundOffCost(qCost)}</td>
            <td>{qCost && roundOffCost(qCost + np1)}</td>
            <td>{qCost && roundOffCost(np1 + np2 + qCost - qCost * 0.005)}</td>
            <td>
              {qCost &&
                roundOffCost(
                  np1 + np2 + np3 + qCost - qCost * 0.005 - qCost * 0.01
                )}
            </td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>Total Cash flow</td>

            <td>{qCost && roundOffCost(qCost * -1)}</td>
            <td>{qCost && roundOffCost((qCost - np1) * -1)}</td>
            <td>{qCost && roundOffCost((qCost - np1 - np2) * -1)}</td>
            <td>{qCost && roundOffCost((qCost - np1 - np2 - np3) * -1)}</td>
          </tr>
        </tbody>
      </table>
      <p
        className="fw-bold mt-4 mb-0 text-uppercase"
        style={{
          fontSize: "1rem",
        }}
      >
        CASH FLOW STATEMENT (5th-8th years):
      </p>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "15%" }}>Particulars</th>

            <th>5th Year</th>
            <th>6th Year</th>
            <th>7th Year</th>
            <th>8th Year</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{(serial = 1)}</td>
            <td>Net Profit</td>

            <td>{roundOffCost(np4)}</td>
            <td>{roundOffCost(np5)}</td>
            <td>{roundOffCost(np6)}</td>
            <td>{roundOffCost(np7)}</td>
          </tr>

          <tr>
            <td></td>
            <td>
              <b>Total</b>
            </td>

            <td>{roundOffCost(np1 + np2 + np3 + np4)}</td>
            <td>{roundOffCost(np1 + np2 + np3 + np4 + np5)}</td>
            <td>{roundOffCost(np1 + np2 + np3 + np4 + np5 + np6)}</td>
            <td>{roundOffCost(np1 + np2 + np3 + np4 + np5 + np6 + np7)}</td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>Investement</td>

            <td>0</td>
            <td>0</td>
            <td>0</td>
            <td>0</td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>Total Assets</td>

            <td>
              {qCost &&
                roundOffCost(
                  qCost - qCost * 0.005 - qCost * 0.01 - qCost * 0.015
                )}
            </td>
            <td>
              {qCost &&
                roundOffCost(
                  qCost -
                    qCost * 0.005 -
                    qCost * 0.01 -
                    qCost * 0.015 -
                    qCost * 0.02
                )}
            </td>
            <td>
              {qCost &&
                roundOffCost(
                  qCost -
                    qCost * 0.005 -
                    qCost * 0.01 -
                    qCost * 0.015 -
                    qCost * 0.02 -
                    qCost * 0.025
                )}
            </td>
            <td>
              {qCost &&
                roundOffCost(
                  qCost -
                    qCost * 0.005 -
                    qCost * 0.01 -
                    qCost * 0.015 -
                    qCost * 0.02 -
                    qCost * 0.025 -
                    qCost * 0.03
                )}
            </td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>Total Valuation</td>

            <td>
              {qCost &&
                roundOffCost(
                  np1 +
                    np2 +
                    np3 +
                    np4 +
                    qCost -
                    qCost * 0.005 -
                    qCost * 0.01 -
                    qCost * 0.015
                )}
            </td>
            <td>
              {qCost &&
                roundOffCost(
                  np1 +
                    np2 +
                    np3 +
                    np4 +
                    np5 +
                    qCost -
                    qCost * 0.005 -
                    qCost * 0.01 -
                    qCost * 0.015 -
                    qCost * 0.02
                )}
            </td>
            <td>
              {qCost &&
                roundOffCost(
                  np1 +
                    np2 +
                    np3 +
                    np4 +
                    np5 +
                    np6 +
                    qCost -
                    qCost * 0.005 -
                    qCost * 0.01 -
                    qCost * 0.015 -
                    qCost * 0.02 -
                    qCost * 0.025
                )}
            </td>
            <td>
              {qCost &&
                roundOffCost(
                  np1 +
                    np2 +
                    np3 +
                    np4 +
                    np5 +
                    np6 +
                    np7 +
                    qCost -
                    qCost * 0.005 -
                    qCost * 0.01 -
                    qCost * 0.015 -
                    qCost * 0.02 -
                    qCost * 0.025 -
                    qCost * 0.03
                )}
            </td>
          </tr>

          <tr>
            <td>{++serial}</td>
            <td>Total Cash flow</td>

            <td>
              {qCost && roundOffCost((qCost - np1 - np2 - np3 - np4) * -1)}
            </td>
            <td>
              {qCost &&
                roundOffCost((qCost - np1 - np2 - np3 - np4 - np5) * -1)}
            </td>
            <td>
              {qCost &&
                roundOffCost((qCost - np1 - np2 - np3 - np4 - np5 - np6) * -1)}
            </td>
            <td>
              {qCost &&
                roundOffCost(
                  (qCost - np1 - np2 - np3 - np4 - np5 - np6 - np7) * -1
                )}
            </td>
          </tr>
        </tbody>
      </table>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>

      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          BREAK EVEN : 1ST YEAR
        </p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "19%" }}>Particulars</th>
              <th style={{ width: "19%" }}>1st year : Q1</th>
              <th style={{ width: "19%" }}>1st year : Q2</th>
              <th style={{ width: "19%" }}>1st year : Q3</th>
              <th style={{ width: "19%" }}>1st year : Q4</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(serial = 1)}</td>
              <td>Production Cost</td>
              <td>{roundOffCost(pc1 / 4)}</td>
              <td>{roundOffCost(pc1 / 4)}</td>
              <td>{roundOffCost(pc1 / 4)}</td>
              <td>{roundOffCost(pc1 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Net Profit</td>
              <td>{roundOffCost(np1 / 4)}</td>
              <td>{roundOffCost(np1 / 4)}</td>
              <td>{roundOffCost(np1 / 4)}</td>
              <td>{roundOffCost(np1 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Asset Recovery</td>
              <td>
                {roundOffCost((breakEvenCost = qCost + pc1 / 4 - np1 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc1 / 4 - np1 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc1 / 4 - np1 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc1 / 4 - np1 / 4) * -1)}
              </td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Breakeven Status</td>

              {qCost &&
                pc1 &&
                np1 &&
                BreakEvenStatus(
                  (breakEvenCostStatus = qCost + pc1 / 4 - np1 / 4) * -1
                )}

              {qCost &&
                pc1 &&
                np1 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc1 / 4 - np1 / 4) * -1
                )}

              {qCost &&
                pc1 &&
                np1 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc1 / 4 - np1 / 4) * -1
                )}

              {qCost &&
                pc1 &&
                np1 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc1 / 4 - np1 / 4) * -1
                )}
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          BREAK EVEN : 2ND YEAR
        </p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "19%" }}>Particulars</th>
              <th style={{ width: "19%" }}>2nd year : Q1</th>
              <th style={{ width: "19%" }}>2nd year : Q2</th>
              <th style={{ width: "19%" }}>2nd year : Q3</th>
              <th style={{ width: "19%" }}>2nd year : Q4</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(serial = 1)}</td>
              <td>Production Cost</td>
              <td>{roundOffCost(pc2 / 4)}</td>
              <td>{roundOffCost(pc2 / 4)}</td>
              <td>{roundOffCost(pc2 / 4)}</td>
              <td>{roundOffCost(pc2 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Net Profit</td>
              <td>{roundOffCost(np2 / 4)}</td>
              <td>{roundOffCost(np2 / 4)}</td>
              <td>{roundOffCost(np2 / 4)}</td>
              <td>{roundOffCost(np2 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Asset Recovery</td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc2 / 4 - np2 / 4) * -1)}
              </td>
              <td>{roundOffCost((breakEvenCost += pc2 / 4 - np2 / 4) * -1)}</td>
              <td>{roundOffCost((breakEvenCost += pc2 / 4 - np2 / 4) * -1)}</td>
              <td>{roundOffCost((breakEvenCost += pc2 / 4 - np2 / 4) * -1)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Breakeven Status</td>

              {qCost &&
                pc2 &&
                np2 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc2 / 4 - np2 / 4) * -1
                )}

              {qCost &&
                pc2 &&
                np2 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc2 / 4 - np2 / 4) * -1
                )}

              {qCost &&
                pc2 &&
                np2 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc2 / 4 - np2 / 4) * -1
                )}

              {qCost &&
                pc2 &&
                np2 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc2 / 4 - np2 / 4) * -1
                )}
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          BREAK EVEN : 3RD YEAR
        </p>
      </div>
      <div style={{ pageBreakInside: "avoid" }}>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "19%" }}>Particulars</th>
              <th style={{ width: "19%" }}>3rd year : Q1</th>
              <th style={{ width: "19%" }}>3rd year : Q2</th>
              <th style={{ width: "19%" }}>3rd year : Q3</th>
              <th style={{ width: "19%" }}>3rd year : Q4</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(serial = 1)}</td>
              <td>Production Cost</td>
              <td>{roundOffCost(pc3 / 4)}</td>
              <td>{roundOffCost(pc3 / 4)}</td>
              <td>{roundOffCost(pc3 / 4)}</td>
              <td>{roundOffCost(pc3 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Net Profit</td>
              <td>{roundOffCost(np3 / 4)}</td>
              <td>{roundOffCost(np3 / 4)}</td>
              <td>{roundOffCost(np3 / 4)}</td>
              <td>{roundOffCost(np3 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Asset Recovery</td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc3 / 4 - np3 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc3 / 4 - np3 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc3 / 4 - np3 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc3 / 4 - np3 / 4) * -1)}
              </td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Breakeven Status</td>

              {qCost &&
                pc3 &&
                np3 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc3 / 4 - np3 / 4) * -1
                )}

              {qCost &&
                pc3 &&
                np3 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc3 / 4 - np3 / 4) * -1
                )}

              {qCost &&
                pc3 &&
                np3 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc3 / 4 - np3 / 4) * -1
                )}

              {qCost &&
                pc3 &&
                np3 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc3 / 4 - np3 / 4) * -1
                )}
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          BREAK EVEN : 4TH YEAR
        </p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "19%" }}>Particulars</th>
              <th style={{ width: "19%" }}>4th year : Q1</th>
              <th style={{ width: "19%" }}>4th year : Q2</th>
              <th style={{ width: "19%" }}>4th year : Q3</th>
              <th style={{ width: "19%" }}>4th year : Q4</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(serial = 1)}</td>
              <td>Production Cost</td>
              <td>{roundOffCost(pc4 / 4)}</td>
              <td>{roundOffCost(pc4 / 4)}</td>
              <td>{roundOffCost(pc4 / 4)}</td>
              <td>{roundOffCost(pc4 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Net Profit</td>
              <td>{roundOffCost(np4 / 4)}</td>
              <td>{roundOffCost(np4 / 4)}</td>
              <td>{roundOffCost(np4 / 4)}</td>
              <td>{roundOffCost(np4 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Asset Recovery</td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc4 / 4 - np4 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc4 / 4 - np4 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc4 / 4 - np4 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc4 / 4 - np4 / 4) * -1)}
              </td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Breakeven Status</td>

              {qCost &&
                pc4 &&
                np4 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc4 / 4 - np4 / 4) * -1
                )}

              {qCost &&
                pc4 &&
                np4 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc4 / 4 - np4 / 4) * -1
                )}

              {qCost &&
                pc4 &&
                np4 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc4 / 4 - np4 / 4) * -1
                )}

              {qCost &&
                pc4 &&
                np4 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc4 / 4 - np4 / 4) * -1
                )}
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          BREAK EVEN : 5TH YEAR
        </p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "19%" }}>Particulars</th>
              <th style={{ width: "19%" }}>5th year : Q1</th>
              <th style={{ width: "19%" }}>5th year : Q2</th>
              <th style={{ width: "19%" }}>5th year : Q3</th>
              <th style={{ width: "19%" }}>5th year : Q4</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(serial = 1)}</td>
              <td>Production Cost</td>
              <td>{roundOffCost(pc5 / 4)}</td>
              <td>{roundOffCost(pc5 / 4)}</td>
              <td>{roundOffCost(pc5 / 4)}</td>
              <td>{roundOffCost(pc5 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Net Profit</td>
              <td>{roundOffCost(np5 / 4)}</td>
              <td>{roundOffCost(np5 / 4)}</td>
              <td>{roundOffCost(np5 / 4)}</td>
              <td>{roundOffCost(np5 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Asset Recovery</td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc5 / 4 - np5 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc5 / 4 - np5 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc5 / 4 - np5 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc5 / 4 - np5 / 4) * -1)}
              </td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Breakeven Status</td>

              {qCost &&
                pc5 &&
                np5 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc5 / 4 - np5 / 4) * -1
                )}

              {qCost &&
                pc5 &&
                np5 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc5 / 4 - np5 / 4) * -1
                )}

              {qCost &&
                pc5 &&
                np5 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc5 / 4 - np5 / 4) * -1
                )}

              {qCost &&
                pc5 &&
                np5 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc5 / 4 - np5 / 4) * -1
                )}
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          BREAK EVEN : 6TH YEAR
        </p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "19%" }}>Particulars</th>
              <th style={{ width: "19%" }}>6th year : Q1</th>
              <th style={{ width: "19%" }}>6th year : Q2</th>
              <th style={{ width: "19%" }}>6th year : Q3</th>
              <th style={{ width: "19%" }}>6th year : Q4</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(serial = 1)}</td>
              <td>Production Cost</td>
              <td>{roundOffCost(pc6 / 4)}</td>
              <td>{roundOffCost(pc6 / 4)}</td>
              <td>{roundOffCost(pc6 / 4)}</td>
              <td>{roundOffCost(pc6 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Net Profit</td>
              <td>{roundOffCost(np6 / 4)}</td>
              <td>{roundOffCost(np6 / 4)}</td>
              <td>{roundOffCost(np6 / 4)}</td>
              <td>{roundOffCost(np6 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Asset Recovery</td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc6 / 4 - np6 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc6 / 4 - np6 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc6 / 4 - np6 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc6 / 4 - np6 / 4) * -1)}
              </td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Breakeven Status</td>

              {qCost &&
                pc6 &&
                np6 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc6 / 4 - np6 / 4) * -1
                )}

              {qCost &&
                pc6 &&
                np6 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc6 / 4 - np6 / 4) * -1
                )}

              {qCost &&
                pc6 &&
                np6 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc6 / 4 - np6 / 4) * -1
                )}

              {qCost &&
                pc6 &&
                np6 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc6 / 4 - np6 / 4) * -1
                )}
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          BREAK EVEN : 7TH YEAR
        </p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "19%" }}>Particulars</th>
              <th style={{ width: "19%" }}>7th year : Q1</th>
              <th style={{ width: "19%" }}>7th year : Q2</th>
              <th style={{ width: "19%" }}>7th year : Q3</th>
              <th style={{ width: "19%" }}>7th year : Q4</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(serial = 1)}</td>
              <td>Production Cost</td>
              <td>{roundOffCost(pc7 / 4)}</td>
              <td>{roundOffCost(pc7 / 4)}</td>
              <td>{roundOffCost(pc7 / 4)}</td>
              <td>{roundOffCost(pc7 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Net Profit</td>
              <td>{roundOffCost(np7 / 4)}</td>
              <td>{roundOffCost(np7 / 4)}</td>
              <td>{roundOffCost(np7 / 4)}</td>
              <td>{roundOffCost(np7 / 4)}</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Asset Recovery</td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc7 / 4 - np7 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc7 / 4 - np7 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc7 / 4 - np7 / 4) * -1)}
              </td>
              <td>
                {" "}
                {roundOffCost((breakEvenCost += pc7 / 4 - np7 / 4) * -1)}
              </td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Breakeven Status</td>

              {qCost &&
                pc7 &&
                np7 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc7 / 4 - np7 / 4) * -1
                )}

              {qCost &&
                pc7 &&
                np7 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc7 / 4 - np7 / 4) * -1
                )}

              {qCost &&
                pc7 &&
                np7 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc7 / 4 - np7 / 4) * -1
                )}

              {qCost &&
                pc7 &&
                np7 &&
                BreakEvenStatus(
                  (breakEvenCostStatus += pc7 / 4 - np7 / 4) * -1
                )}
            </tr>
          </tbody>
        </table>
      </div>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
    </div>
  );
};
export default FinancialAnalysis;
